import { Controller } from '@hotwired/stimulus'
import { delegate } from 'tippy.js'

export default class extends Controller {
  connect() {
    this.setupTippy()
  }

  setupTippy() {
    delegate('body', {
      content: reference => {
        const templateId = reference.dataset.tippyTemplate

        if (reference.dataset.tippyContent) {
          return reference.dataset.tippyContent
        } else if (templateId) {
          return document.getElementById(templateId)?.cloneNode(true).innerHTML
        }
      },
      target: '[data-tippy-content]',
      animation: 'shift-away',
      appendTo: el => {
        const dialog = el.closest('dialog')
        if (dialog) return dialog

        return document.body
      },
      duration: 150,
      allowHTML: true,
      popperOptions: {
        modifiers: [
          { name: 'flip', options: { fallbackPlacements: ['bottom', 'top'] } }
        ]
      }
    })
  }
}
